import { i18n } from 'i18n';
import { ELanguages } from 'shared/typings';

export const LANGUAGES = [
	{
		label: i18n.t('RU'),
		value: ELanguages.RU,
	},
];

export const FULL_LANGUAGES = [
	{
		label: i18n.t('Русский'),
		value: ELanguages.RU,
	},
];

export const DEFAULT_LANGUAGE = (language: ELanguages) => {
	return LANGUAGES.find(({ value }) => language.includes(value))?.value || ELanguages.RU;
};
